module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"notice_title":"[{brand_name} Rewards Information]","new_review_button_label_with_mileage":"Write a review and get max %{expected_mileage} rewards","new_review_button_label":"Write a review","max_mileage":"Max {0} available","no_review_message":"There are no reviews to write.","money":"rewards"}}')
  delete Component.options._Ctor
}
